module.exports = __webpack_public_path__ + "img/黔江重庆阿蓬江国家湿地公园@2x.588102ee.png";